import { PropertyGridSection } from '../../../components/PropertyGrid/columnSections/PropertyGridSection.tsx';
import {
  getAloftAreaJSONPropertyGridField,
  getNumberPropertyGridField,
} from '../../../components/PropertyGrid/fields/utils.tsx';
import { PropertyGridSectionProps } from '../../../components/PropertyGrid/types.ts';

const ONE_TO_SIX = [1, 2, 3, 4, 5, 6];

const prefixedNumbersToOptions = (prefix: string, options: number[]) =>
  options?.map((opt) => ({ label: `${prefix}${opt}`, value: opt }));

export const FeatureGridMainDwellingSection = (props: PropertyGridSectionProps) => (
  <PropertyGridSection
    {...props}
    title="Main Dwelling"
    hasSeparateArvValue
    fields={[
      getNumberPropertyGridField('editableData.improvements.age', 'Actual Age'),
      getNumberPropertyGridField('editableData.improvements.bedrooms', 'Bedrooms'),
      getNumberPropertyGridField('editableData.improvements.fullBaths', 'Baths, Full'),
      getNumberPropertyGridField('editableData.improvements.halfBaths', 'Baths, Half'),
      getAloftAreaJSONPropertyGridField('editableData.improvements.gla', 'GLA'),
      getNumberPropertyGridField(
        'editableData.improvements.uadQuality',
        'Quality',
        undefined,
        prefixedNumbersToOptions('Q', ONE_TO_SIX),
        true,
      ),
      getNumberPropertyGridField(
        'editableData.improvements.uadCondition',
        'Condition',
        undefined,
        prefixedNumbersToOptions('C', ONE_TO_SIX),
        true,
      ),
    ]}
  />
);
